import React from "react"
import styled from '@emotion/styled'

const Fieldset = styled.fieldset`
  width: 100%;
  margin: 0 0 13px 0;
  display: flex;
  flex-direction: column;
  text-align: left;
  border: 0;
  margin: 0;
  padding: 0;
  position: relative;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
  'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
  'Segoe UI Symbol';
  .label {
    font-size: 14px;
    line-height: 1.14;
    color: #191919;
  }
  textarea {
    resize: none;
  }
  label {
    margin-bottom: 6px;
    font-size: 12.5px;
    font-weight: 600;
    color: #222;
  }
  input,
  textarea,
  select {
    flex-direction: row;
    display: flex;
    width: 100%;
    padding: 15px 17px;
    box-sizing: border-box;
    outline: 0;
    margin-bottom: 3px;
    border-radius: 2px;
    font-weight: 400;
    font-size: 1.1rem;
    color: ${props => !props.app? 'inherit': `${props.theme.text.base}`};
    background-color: ${props => !props.app? '#ffffff': 'transparent'};
    border: 0;
    box-shadow: ${props => !props.app? '0 0 0 1px rgb(0,0,0,.2)': `0 0 0 2px ${props.theme.text.base}40`};
    transition: box-shadow 0.2s ease-in-out;
    -webkit-appearance: none;
    appearance: none;
    &:active,
    &:focus {
      box-shadow: ${props => !props.app? '0 0 0 2px #222': `0 0 0 2px ${props.theme.text.base}`};

    }
    &::placeholder {
      color: ${props => !props.app? '#868e96': `${props.theme.text.base}40`};
     }
    &.error {
    input {
      box-shadow: 0 0 0 2px #ff0000;
    }
  }
  }
`


export default ({ app, children, error, label, ...props }) => (
  <Fieldset app={app}>
    {label && <label>{label}</label>}
    {children}
  </Fieldset>
)
